import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

type ThisProjectMessages = {
    optIn: string,
    step: {
        success: {
            redirect: string,
        }
    }
};

export const messagesTH: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    schoolName: 'โรงเรียน',
    infoShared1: ' ',
    informationTransferredToUS: ' ',
    infoShared2: 'ข้อมูลที่กรอกที่นี่จะถูกใช้เพื่อการตรวจสอบและแบ่งปันกับ {companyName}.',
    optIn: `การคลิกที่ลิงค์นี้แสดงว่าคุณยอมรับการประมวลผลข้อมูลเพื่อตรวจสอบสิทธิ์ที่ระบุไว้ในนโยบายความเป็นส่วนตัว <a target="_blank" class="sid-link" href="https://www.sheerid.com/privacy-policy/">นโยบายความเป็นส่วนตัวของ SheerID</a> และ <a target="_blank" class="sid-link" href="https://www.lenovo.com/privacy/">นโยบายความเป็นส่วนตัวของ Lenovo</a>. ข้อมูลจะแชร์กับ Lenovo โอนไปยังสหรัฐอเมริกาและประมวลผลตามนโยบายความเป็นส่วนตัวของ SheerID และนโยบายความเป็นส่วนตัวของ Lenovo`,
    country:'Country/Region',
    countryPlaceholder:"Country/Region",
    countries: {
        HK: 'Hong Kong S.A.R. of China',
        TW: 'Taiwan Region',
    },
    step: {
        personalInfo: {
            subtitle: 'ยืนยันว่าคุณเป็นนักเรียน/นักศึกษาสถาบันการศึกษาที่มีการมอบปริญาบัตรโดยกระทรวงศึกษาทิการ',
            howDoesVerifyingWorkDetails: 'เพื่อมีสิทธิ์รับข้อเสนอนี้ ปัจจุบันคุณต้องสมัครเรียนอยู่ ในโรงเรียนที่ได้รับการรับรองวุฒิการศึกษาระดับอุดมศึกษา<br><br>Lenovo ใช้ SheerID เพื่อนคู่หูที่ไว้ใจได้เพื่อยืนยันว่าปัจจุบันคุณเป็นนักเรียน SheerID รวบรวมเฉพาะข้อมูลที่ช่วยในการตรวจสอบสิทธิ์ของคุณ อาจขอข้อมูลเพิ่มเติมหรือเอกสารประกอบ',
        },
        success: {
            redirectButtonText: 'ไปที่ Lenovo',
            redirect: 'ไปที่ Lenovo',
            emailNotification: 'เราได้ส่งลิงก์นี้ให้กับคุณทางอีเมลเพื่อให้คุณสามารถดำเนินการซื้อสินค้าต่อได้ในภายหลัง ลูกค้าสามารถค้นหาได้ทางช่องทางอีเมลของท่านโดยส่งจากอีเมล Verify@sheerid.com'
        },
        docUpload: {
            title: 'เราต้องการภาพถ่ายบัตรประจำตัวนักศึกษาและตารางเรียนของคุณ',
        },
        emailLoop: {
            title:'ตรวจสอบอีเมลของคุณ',
            subtitleWithEmail:'อีเมลถูกส่งไปยัง {email} พร้อมลิงก์ส่วนบุคคลเพื่อให้ดำเนินขั้นตอนการยืนยันให้เสร็จสมบูรณ์',
            subtitleWithoutEmail:'อีเมลถูกส่งไปยังบัญชีอีเมลของคุณพร้อมลิงก์ส่วนบุคคลเพื่อให้ทำขั้นตอนการยืนยันให้เสร็จสมบูรณ์',
            subtitle2:'โปรดตรวจสอบอีเมลจากเรา (Verify@sheerid.com) สำหรับรายละเอียดทั้งหมด',
            successResend:'ส่งอีเมลอีกครั้งเรียบร้อยแล้ว"',
            resendButton:'ส่งใหม่',
            errors:{
                resend:'เกิดข้อผิดพลาดในการส่งอีเมล',
            },
            skipEmail:'ไม่สามารถกู้คืนอีเมลนี้ได้ คลิก',
            skipEmailCTA:'ที่นี่',
            skipEmail2:'เพื่อดำเนินการต่อ'
        }
    },
};
